import React, { useState, useContext } from "react";
import { AppContext } from 'store/AppContext';
import AtkvaediLookup from "./components/AtkvaediLookup";
import BreytaAtkvaediTable from "./components/BreytaAtkvaediTable";
import BreytaAtkvaediSnackbar from "./components/BreytaAtkvaediSnackbar";

const BreytaAtkvaedi = () => {
  const context = useContext(AppContext);
  const [data, setData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const roles = context.user.get.details.role;
  const hasRequiredRole = roles.some(x => x === 'utankjorfundarkerfi.useradmin' | x === 'utankjorfundarkerfi.admin');

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
  };
  
  if (hasRequiredRole) {
    return (
      <div>
        <AtkvaediLookup setData={setData} />
        <BreytaAtkvaediTable data={data} setData={setData} setSnackbarOpen={setSnackbarOpen} />
        <BreytaAtkvaediSnackbar open={snackbarOpen} handleClose={handleSnackbarClose}  />
      </div>
    );
  }

  return null;
}

export default BreytaAtkvaedi;